import { useEffect, type ReactNode } from "react";
import { Icon } from "./Icon";

interface Props {
  open: boolean;
  onClose: () => void;
  label: string;
  children: ReactNode;
  /** Extra classes, like the prototype's `wide`. */
  className?: string;
}

/** The prototype's sheet: a dialog in the middle of the screen, rising from the bottom on phones, over a scrim. */
export function Sheet({ open, onClose, label, children, className }: Props) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  return (
    <>
      <div className={open ? "scrim on" : "scrim"} onClick={onClose} />
      <div className={`sheet${open ? " on" : ""}${className ? ` ${className}` : ""}`} role="dialog" aria-modal="true" aria-label={label} aria-hidden={!open}>
        <div className="grab" />
        <button type="button" className="x" onClick={onClose} aria-label="Close">
          <Icon name="x" />
        </button>
        {open && children}
      </div>
    </>
  );
}
